import { BlockType } from '../../types/index.js';
import { InputBlock as Component } from './Block.js';
export const RegisteredInputBlock = (_intl) => ({
    recommendedName: 'Input',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            copy: false,
        },
    },
});
//# sourceMappingURL=registered.js.map